import { CvDateFormatter, DATEFORMAT } from "@cv-invision/cv.component-library.ux";

export class LENDINGQB_LOG_DETAIL {
	private _columns: Array<any>;

	constructor(private dateService: CvDateFormatter) {
        this._columns = [
            {
                headerName: 'ID',
                field: 'id',
                width: 130
            },
            {
                headerName: 'Transaction ID',
                field: 'transactionId',
                width: 130
            },
            {
                headerName: 'Event Name',
                field: 'eventName',
                width: 100
            },
            {
                headerName: 'Lending QB Order ID',
                field: 'lendingQbOrderId',
                width: 150
            },
            {
                headerName: 'Duration',
                field: 'duration',
                width: 90
            },
            {
                headerName: 'Created',
                field: 'created',
                width: 160,
                valueFormatter: params => dateService.format(DATEFORMAT.EMPTY, params.data.created)
            }
        ];
    }



	get columns(): Array<any> {
		return this._columns;
	}
}
